module.exports = __webpack_public_path__ + "assets/e381d1a8808a7c07b20c25ba7f105c05.png";